import xCloseIcon from '@shared/assets/images/x-close-lg_icon.svg';

import styles from './CommentDetailModal.module.scss';

/**
 * CommentDetailModal 컴포넌트 (페이지 전용)
 * - 코멘트 상세 확인 모달
 * - 본인 코멘트: X 닫기 버튼 + 수정/삭제 버튼 표시
 * - 타인 코멘트: 확인 버튼만 표시
 * - 백그라운드 오버레이 없음 (투명)
 *
 * @param {boolean} isOpen 모달 열림 여부
 * @param {Object} comment 코멘트 데이터 { idx, comment, enumber, enumber_name }
 * @param {boolean} isOwner 본인 작성 코멘트 여부
 * @param {Function} onClose 닫기 핸들러
 * @param {Function} onModify 수정 버튼 클릭 핸들러
 * @param {Function} onDelete 삭제 버튼 클릭 핸들러
 */
function CommentDetailModal({ isOpen, comment, isOwner = false, onClose, onModify, onDelete }) {
  if (!isOpen || !comment) return null;

  const commentText = comment.comment || '';

  return (
    <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
      <div
        className={`${styles.modalContainer} ${isOwner ? styles.ownerMode : styles.viewerMode}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* X 닫기 버튼 - 본인 코멘트일 때만 표시 */}
        {isOwner && (
          <button type="button" className={styles.closeButton} onClick={onClose} aria-label="닫기">
            <img src={xCloseIcon} alt="" className={styles.closeIcon} />
          </button>
        )}

        {/* 컨텐츠 영역 */}
        <div className={styles.contentWrapper}>
          {/* 타이틀 */}
          <h2 className={styles.title}>코멘트 확인</h2>

          {/* 코멘트 내용 */}
          <div className={`${styles.commentBox} ${isOwner ? styles.ownerBox : ''}`}>
            <p className={styles.commentText}>{commentText}</p>
          </div>

          {/* 버튼 영역 */}
          <div className={styles.buttonGroup}>
            {isOwner ? (
              <>
                <button type="button" className={styles.deleteButton} onClick={onDelete}>
                  삭제
                </button>
                <button type="button" className={styles.modifyButton} onClick={onModify}>
                  수정
                </button>
              </>
            ) : (
              <button type="button" className={styles.confirmButton} onClick={onClose}>
                확인
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommentDetailModal;
